export default {"src":"/_next/static/media/404.74def32c.gif","height":400,"width":1920,"blurWidth":0,"blurHeight":0};